import classnames from 'classnames';
import React from 'react';
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';

interface Props extends RouteComponentProps {
  id?: string;
  name: string;
  path: string;
}

const LinkTab = withRouter((props: Props) => {
  const { id, location, path, name } = props;
  const selected = location.pathname === path;

  return (
    <NavLink to={path} className="decoration-none" id={id}>
      <div className="mr4 cursor-pointer">
        <div
          className={classnames('font-size-5', {
            'color-primary-dark': selected,
            'black-2': !selected,
          })}
          style={{ margin: '4px' }}
        >
          {name}
        </div>
        <div
          className={classnames(
            'bb-solid bb-width-3',
            selected ? 'bb-primary-dark' : 'bb-transparent'
          )}
        />
      </div>
    </NavLink>
  );
});

export default LinkTab;
